import React from 'react';
import { Alert, Flex, Typography } from '@duxton-web/ui';

const MonitoringGuidance: React.FC = () => {
  return (
    <Alert
      data-testid="canary-monitoring-guidance"
      type="info"
      showIcon
      message="Choose how to monitor this rollout"
      description={
        <Flex vertical gap={4}>
          <Typography.Text>
            <Typography.Text strong>Metric query</Typography.Text>
            <Typography.Text type="secondary">
              {' '}
              — use a custom Datadog query and set min/max thresholds.
            </Typography.Text>
          </Typography.Text>
          <Typography.Text>
            <Typography.Text strong>Datadog monitor</Typography.Text>
            <Typography.Text type="secondary">
              {' '}
              — reuse an existing monitor; only Alert stops the rollout.
            </Typography.Text>
          </Typography.Text>
          <Typography.Text type="secondary">
            Use either signal type, or combine both for broader coverage.
          </Typography.Text>
        </Flex>
      }
    />
  );
};

export default MonitoringGuidance;
